import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const TONS = {
  erro: "border-destructive/25 bg-destructive/5 text-destructive",
  alerta: "border-amber-500/30 bg-amber-500/[.07] text-amber-800 dark:text-amber-300",
  info: "border-border bg-muted-soft text-muted-foreground",
} as const;

/** Faixa de aviso acima das tabelas das abas da folha (CLT, Pendências). */
export const AvisoContextual = ({
  tom,
  icon: Icon,
  children,
  className,
}: {
  tom: keyof typeof TONS;
  icon: LucideIcon;
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn("flex items-start gap-2.5 rounded-[10px] border px-4 py-3 text-[13px]", TONS[tom], className)}>
    <Icon className="mt-px h-4 w-4 shrink-0" />
    <div className="min-w-0">{children}</div>
  </div>
);
